import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';
import { Auth } from '@freelancer/auth';
import { delay, map } from 'rxjs/operators';

export const ShellGuard: CanMatchFn = route => {
  const auth = inject(Auth);

  return auth.isLoggedIn().pipe(
    map(isLoggedIn => isLoggedIn === route.data?.loggedIn),
    // Wait for route animations to play.
    delay(0),
  );
};
